import { styled, Paper } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  ...theme.typography.body2,
  padding: theme.spacing(theme.breakpoints.down("sm") ? 1.5 : 2),
  textAlign: "left",
  color: theme.palette.text.secondary,
  height: "100%",
  borderRadius: theme.shape.borderRadius,
  transition: "transform 0.2s, box-shadow 0.2s",

  // Mobile-specific styles
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.875rem",
    lineHeight: 1.5,
    minHeight: "auto",
    "&:active": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[2],
    },
  },

  // Tablet and desktop hover
  [theme.breakpoints.up("md")]: {
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[4],
    },
  },

  // Mobile and tablet touch feedback (gentler hover)
  [theme.breakpoints.down("md")]: {
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[2],
    },
  },

  ...(theme.palette.mode === "dark" && {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  }),
}));

export default StyledPaper;
